<ion-header>
  <ion-toolbar>
    <ion-title>Quick Update Needed</ion-title>
    <!-- No close button - this modal cannot be dismissed -->
  </ion-toolbar>
</ion-header>

<div class="modal-body">
  <div class="modal-content">
    <div class="update-icon">
      <ion-icon name="refresh-outline"></ion-icon>
    </div>

    <!-- Web users -->
    @if (!isNative) {
      <ion-text class="info-text">
        <p class="main-message">This is rare, but this update is required for the app to continue working properly.</p>
        <p class="sub-message">Thanks for bearing with us.</p>
        <p class="version-info">Minimum version: {{ minimumAppVersion }}</p>
      </ion-text>

      <div class="button-group">
        <ion-button expand="block" (click)="onRefresh()" class="action-button">
          <ion-icon name="refresh-outline" slot="start"></ion-icon>
          Update to Continue
        </ion-button>
      </div>

      <p class="cache-hint">If refreshing doesn't work, you may need to clear your site cache.</p>

      <!-- Show app download option for mobile web users -->
      @if (showMobileAppPromo) {
        <div class="app-promo">
          <p class="promo-text">Or download our mobile app:</p>
          <div class="store-buttons">
            @if (isIosUserAgent) {
              <ion-button fill="outline" (click)="onOpenAppStore()" class="store-button">
                <ion-icon name="logo-apple" slot="start"></ion-icon>
                App Store
              </ion-button>
            } @else {
              <ion-button fill="outline" (click)="onOpenPlayStore()" class="store-button">
                <ion-icon name="logo-google-playstore" slot="start"></ion-icon>
                Play Store
              </ion-button>
            }
          </div>
        </div>
      }
    }

    <!-- Native users -->
    @if (isNative) {
      <ion-text class="info-text">
        <p class="main-message">This is rare, but this update is required for the app to continue working properly.</p>
        <p class="sub-message">Thanks for bearing with us.</p>
        <p class="version-info">Minimum version: {{ minimumAppVersion }}</p>
      </ion-text>

      <!-- Native iOS: Show App Store button -->
      @if (platform === 'ios') {
        <div class="button-group">
          <ion-button expand="block" (click)="onOpenAppStore()" class="action-button">
            Update in App Store
          </ion-button>
        </div>
      }

      <!-- Native Android: Show Play Store button -->
      @if (platform === 'android') {
        <div class="button-group">
          <ion-button expand="block" (click)="onOpenPlayStore()" class="action-button">
            Update in Play Store
          </ion-button>
        </div>
      }
    }
  </div>
</div>
